import { create } from 'zustand';

interface FontsTypeStore {
  fonts: string[];
  setFonts: (fonts: string[]) => void;
}

export const useFontsStore = create<FontsTypeStore>((set) => ({
  fonts: [],
  setFonts: (fonts) => {
    set({ fonts });
  },
}));
